<template>
  <div class="mbw-shadow rounded-5 p-4 mx-2 h-100">
    <div class="text-orange fw-bold text-uppercase my-2 ">{{ item.type }}</div>
    <h2 class="fs-4 pt-0 pb-0 text-uppercase" v-html="item.title.rendered"></h2>
    <p v-if="item.acf.subtitle">{{ item.acf.subtitle }}</p>

    <div v-if="item.acf.activities">
      <h3 class="text-transform_unset text-black">Activités proposées</h3>
      <p class="association-activites-proposees_texte">{{ item.acf.activities }}</p>
    </div>

    <Address :item="item"/>

    <div v-if="item.acf.lieu_de_pratique && item.acf.lieu_de_pratique.length > 0">
      <h3 class="text-transform_unset text-black">Lieux de pratique</h3>
      <div v-for="item in item.acf.lieu_de_pratique">
        {{ [item.place_name, item.address].filter(Boolean).join(' - ') }}
      </div>
    </div>

    <div v-if="item.acf.notes">
      <h3 class="text-transform_unset text-black">Description</h3>
      <p class="association-description_texte">{{ item.acf.notes }}</p>
    </div>

    <h3 class="text-transform_unset text-black">Informations complémentaires</h3>
    <p>
      <span class="d-block"><b>Siège social :</b> {{ item.acf.siege_social }}</span>
      <span class="d-block"><b>Adresse de contact :</b> {{ item.acf.adresse_de_contact }}</span>

      <span class="d-block" v-if="item.acf.suggested_age">
        <b>Âge conseillé :</b> {{ item.acf.suggested_age }}
      </span>
    </p>

    <h3 class="text-transform_unset text-black">Contact</h3>
    <p>
      <span class="d-block fw-bold">{{ item.acf.contact.name }}</span>
      <span class="d-block"><i class="fa fa-phone"></i> {{ item.acf.contact.phone }}</span>
      <span class="d-block"><i class="fa fa-envelope"></i> {{ item.acf.contact.email }}</span>
    </p>

    <h3 class="text-transform_unset text-black">Site</h3>
    <p>
      <a target="_blank" href="{{item.acf.website.url}}">{{ item.acf.website.anchor }}</a>
    </p>

    <div v-if="item.acf.social_network && item.acf.social_network.length > 0">
      <h3 class="text-transform_unset text-black">Réseaux sociaux</h3>
      <div v-for="item in item.acf.social_network">
        <a target="_blank" class="p-0 btn btn-link" href="{{item.url}}">
          {{item.name}}
        </a>
      </div>
    </div>
  </div>
</template>

<script>
import Address from "@/components/listing/includes/Address.vue";
import Services from "@/components/listing/includes/Services.vue";

export default {
  name: 'AssociationItem',

  components: {Services, Address},

  props: {
    item: Object
  },
}
</script>

<style scoped>
.association-activites-proposees_texte {
  color: var( --e-global-color-secondary );
}

.association-description_texte {
  font-style: italic;
}
</style>